// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3CMAe","title":"AfterFrontImage_title__rhmuv"};